var map = {
	"./404.svg": 3530,
	"./baseinfo.svg": 338,
	"./bug.svg": 7130,
	"./caigou.svg": 8963,
	"./chart.svg": 8545,
	"./clipboard.svg": 6637,
	"./codec.svg": 2830,
	"./component.svg": 2406,
	"./dashboard.svg": 8749,
	"./defication.svg": 5462,
	"./dep.svg": 8882,
	"./dept.svg": 477,
	"./documentation.svg": 9607,
	"./drag.svg": 224,
	"./edit.svg": 8352,
	"./education.svg": 3085,
	"./email.svg": 1533,
	"./example.svg": 9892,
	"./excel.svg": 9139,
	"./exit-fullscreen.svg": 871,
	"./express.svg": 2695,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./fh.svg": 9590,
	"./form.svg": 4062,
	"./fullscreen.svg": 6286,
	"./guide.svg": 5860,
	"./icon.svg": 9789,
	"./international.svg": 3906,
	"./language.svg": 9424,
	"./link.svg": 4121,
	"./list.svg": 2672,
	"./lock.svg": 6648,
	"./message.svg": 860,
	"./money.svg": 1116,
	"./nested.svg": 1476,
	"./order.svg": 3207,
	"./orderdefi.svg": 4155,
	"./orderitemdefi.svg": 9617,
	"./ordertypedefi.svg": 5928,
	"./paraset.svg": 3482,
	"./password.svg": 6408,
	"./pdf.svg": 6500,
	"./people.svg": 2011,
	"./peoples.svg": 5765,
	"./protocol.svg": 8619,
	"./qq.svg": 6869,
	"./search.svg": 2042,
	"./seqrangset.svg": 7718,
	"./set.svg": 5507,
	"./sf.svg": 1315,
	"./sh.svg": 4904,
	"./shopping.svg": 8764,
	"./size.svg": 985,
	"./skill.svg": 8673,
	"./star.svg": 8019,
	"./sysmanage.svg": 3054,
	"./tab.svg": 817,
	"./table.svg": 3797,
	"./tagproduct.svg": 937,
	"./tagpurchase.svg": 2335,
	"./tagpurchase1.svg": 9582,
	"./tags.svg": 6295,
	"./theme.svg": 987,
	"./tree-table.svg": 85,
	"./tree.svg": 964,
	"./user.svg": 42,
	"./wechat.svg": 267,
	"./zip.svg": 7276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;